import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

// Désactiver les logs en production (garde console.error pour les vraies erreurs)
if (environment.production) {
  console.log = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
  // console.error reste actif pour les erreurs critiques
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
